import React, { useState, useEffect } from 'react';
import { WifiOff, Wifi, RefreshCw } from 'lucide-react';
import { Badge } from './ui/badge';
import { Button } from './ui/button';
import { toast } from 'sonner';

export const OfflineIndicator = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showBadge, setShowBadge] = useState(!navigator.onLine);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      toast.success('Connexion rétablie', {
        description: 'Vous êtes de nouveau en ligne.'
      });
      setTimeout(() => setShowBadge(false), 3000);
    };

    const handleOffline = () => {
      setIsOnline(false);
      setShowBadge(true);
      toast.warning('Mode hors ligne', {
        description: 'Vous travaillez hors connexion. Certaines fonctionnalités peuvent être limitées.'
      });
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  const handleRefresh = () => {
    if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
      navigator.serviceWorker.controller.postMessage({ type: 'SKIP_WAITING' });
    }
    window.location.reload();
  };

  if (!showBadge && isOnline) return null;

  return (
    <div className={`fixed bottom-4 left-4 z-50 flex items-center gap-2 px-4 py-2 rounded-full shadow-lg transition-all duration-300 ${
      isOnline 
        ? 'bg-emerald-100 text-emerald-800 border border-emerald-300' 
        : 'bg-amber-100 text-amber-800 border border-amber-300'
    }`}>
      {isOnline ? (
        <>
          <Wifi className="w-4 h-4" />
          <span className="text-sm font-medium">En ligne</span>
        </>
      ) : (
        <>
          <WifiOff className="w-4 h-4 animate-pulse" />
          <span className="text-sm font-medium">Hors ligne</span>
          <Button 
            variant="ghost" 
            size="sm" 
            onClick={handleRefresh}
            className="h-6 px-2 hover:bg-amber-200"
          >
            <RefreshCw className="w-3 h-3" />
          </Button>
        </>
      )}
    </div>
  );
};

export default OfflineIndicator;
